import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, ListItem, ProgressIndicator } from '@veneer/core';
import ModalError, { ModalErrorDetail } from '../../components/Modals/Error';
import imageSamplePhotobook from '../../assets/images/sample-photobook.png';
import { ScreenInfo } from '../../jarvis/dataCollection';
import HeaderBar from '../../components/HeaderBar';
import './index.css';
import { usePhotobookApiWebHttpClient } from '../../helpers/useJarvisApiWebHttpClient';
import { PhotobookApi } from '../../helpers/apis/photobookApi';

declare global {
  interface Window {
    launchMediaclipDesigner: (projectId: string, userMediaclipToken: string, keepAliveUrl: string) => void;
  }
}

const ListProject = () => {
  const [loading, setLoading] = useState(true);
  const [projectList, setProjectList] = useState([]);
  const [, setUserMediaclipToken] = useState('');
  const [hasError, setHasError] = useState(false);
  const [errorDetail, setErrorDetail] = useState<ModalErrorDetail>();

  const history = useHistory();

  // const keepAliveUrl = baseUrl + '/api/v1/client/mediaclip/public/renewToken'; // From the "The renew-token page" section

  const screenInfo: ScreenInfo = { name: 'ListProject', activity: 'OrderPhotobook-v01' };

  const photobookApi = new PhotobookApi(usePhotobookApiWebHttpClient());

  useEffect(() => {
    obtainListProjects();
  }, []);

  const obtainListProjects = async () => {
    try {
      const response = await photobookApi.getProjects();
      setProjectList(response.data.projects);
      setUserMediaclipToken(response.data.userMediaclipToken);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setHasError(true);
      setErrorDetail({
        context: 'Error obtaining list of projects',
        ...(error instanceof Error && { error: error }),
      });
      console.log(error);
    }
  };

  const deleteProject = async (projectId: string) => {
    try {
      console.log('Calling delete project endpoint');
      await photobookApi.deleteProject(projectId);
      setProjectList(projectList.filter((item) => item['id'] != projectId));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setHasError(true);
      setErrorDetail({
        context: 'Error obtaining list of projects',
        ...(error instanceof Error && { error: error }),
      });
      console.log(error);
    }
  };

  const onClickBack = () => {
    history.push('/');
  };

  if (hasError) {
    return <ModalError state={hasError} detail={errorDetail as ModalErrorDetail} screenInfo={screenInfo} />;
  }

  if (loading) {
    return (
      <div className="spinner">
        <ProgressIndicator />
      </div>
    );
  } else {
    return (
      <section className="ListProjectsPage">
        <HeaderBar handleBack={onClickBack} title="HP Smart" />
        <div id="designer" className="mediaclip-designer-wrapper">
          {projectList.length !== 0 ? (
            projectList.map((project) => (
              <div key={project['id']}>
                <ListItem
                  leadingArea={<img src={imageSamplePhotobook} alt="printer" width="36px" height="36px" />}
                  centerArea={
                    <div style={{ display: 'inline-grid' }}>
                      <div className="vn-list-item__title">{project['title']}</div>
                      <div className="vn-list-item__subtitle">
                        {new Date(project['createdDate']).toLocaleString('en-US')}
                      </div>
                    </div>
                  }
                  trailingArea={
                    <div>
                      <Button appearance="negative" aria-label="remove" onClick={() => deleteProject(project['id'])}>
                        Remove
                      </Button>
                    </div>
                  }
                />
              </div>
            ))
          ) : (
            <p>No projects found.</p>
          )}
        </div>
      </section>
    );
  }
};

export default ListProject;
